// export const uploadUrl = "//dev.328ym.com/smsapi";
export const uploadUrl = '//hwy.328ym.com/smsapi'
